'use client'

import React from 'react'
import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import type { Video } from '@/payload-types'
import { VideosCarousel } from '../Videos/VideosCarousel'

interface ResourcesVideosProps {
  videos: Video[]
}

export function ResourcesVideos({ videos }: ResourcesVideosProps) {
  if (!videos || videos.length === 0) {
    return null
  }

  return (
    <section className="py-8 md:py-12 px-6 md:px-12 lg:px-16">
      <div className="max-w-380 mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <h2 className="text-2xl md:text-3xl font-medium text-gray-900">Videos</h2>
          <Link
            href="/videos"
            className="flex items-center gap-1.5 text-brand-gold hover:text-brand-gold-light text-sm font-medium transition-colors"
          >
            <span>See all videos</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* A row rather than a grid: clips are portrait and full-length videos are
            widescreen, so one shared card height keeps both formats on one line. */}
        <VideosCarousel videos={videos} />
      </div>
    </section>
  )
}
